var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegenerateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.67969 0.975586C9.79604 0.695274 10.1484 0.677284 10.2939 0.922852L10.3193 0.975586L11.3438 3.44238C12.3005 5.74718 14.0858 7.59318 16.3369 8.5918V8.59082L19.0312 9.78809C19.1699 9.84965 19.249 9.97774 19.249 10.1387C19.249 10.2995 19.1699 10.4277 19.0312 10.4893L16.249 11.7246C14.0555 12.6984 12.3009 14.4783 11.3281 16.707L10.3174 19.0225H10.3164C10.1981 19.2931 9.85624 19.3117 9.70898 19.0732L9.68262 19.0215L8.67188 16.707V16.7061C7.69829 14.4768 5.94365 12.6975 3.74902 11.7236L0.967773 10.4893C0.829189 10.4277 0.750058 10.2995 0.75 10.1387C0.75 9.9778 0.829219 9.84967 0.967773 9.78809L3.66309 8.59082C5.77319 7.6538 7.47407 5.97381 8.4668 3.86914L8.65625 3.44238L9.67969 0.975586Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8179 1.28223C17.2368 2.13177 17.9243 2.81729 18.7759 3.22461C17.9322 3.619 17.2457 4.28658 16.8179 5.11719C16.39 4.28655 15.7036 3.61896 14.8599 3.22461C15.7115 2.81732 16.3989 2.1318 16.8179 1.28223Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27246 16.2046C3.11334 16.2046 3.79575 16.8862 3.7959 17.7271C3.7959 18.568 3.11343 19.2505 2.27246 19.2505C1.43161 19.2504 0.75 18.568 0.75 17.7271C0.750146 16.8863 1.4317 16.2047 2.27246 16.2046Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegenerateIcon);
export default __webpack_public_path__ + "static/media/RegenerateIcon.d1ca1f1775b4196cb6d90286d155af51.svg";
export { ForwardRef as ReactComponent };